export const CHAT_OPEN = 'CHAT_OPEN'
export const CHAT_CLOSE = 'CHAT_CLOSE'
export const CHAT_TOGGLE = 'CHAT_TOGGLE'